import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["classes", "field", "message", "placeholder", "mode", "counter", "maxLength"];
import React, { useEffect, useState } from 'react';
import { number, node, oneOf, oneOfType, shape, string } from 'prop-types';
import { TextArea as InformedTextArea } from 'informed';
import useFieldState from '@magento/peregrine/lib/hooks/hook-wrappers/useInformedFieldStateWrapper';
import { Message } from '@magento/venia-ui/lib/components/Field';
import CharacterCounter from '../../CharacterCounter';
import defaultClasses from './textArea.module.css';
import { useFieldTouched, useMergeCssClasses } from '../../../Utils/utils';

var TextArea = function TextArea(props) {
  var _fieldState$value2, _fieldState$value$len, _fieldState$value3;

  var _useFieldTouched = useFieldTouched(),
      _useFieldTouched2 = _slicedToArray(_useFieldTouched, 2),
      isTouched = _useFieldTouched2[0],
      setIsTouched = _useFieldTouched2[1];

  var propClasses = props.classes,
      field = props.field,
      message = props.message,
      placeholder = props.placeholder,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'light' : _props$mode,
      _props$counter = props.counter,
      counter = _props$counter === void 0 ? false : _props$counter,
      _props$maxLength = props.maxLength,
      maxLength = _props$maxLength === void 0 ? 150 : _props$maxLength,
      rest = _objectWithoutProperties(props, _excluded);

  var fieldState = useFieldState(field);
  var classes = useMergeCssClasses(defaultClasses, propClasses);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var isTouchedClass = isTouched ? classes.placeholder_active : classes.placeholder;
  var inputClass = fieldState.error ? classes.input_error : classes.input;

  if (mode == 'dark') {
    inputClass = fieldState.error ? classes.input_error_dark : classes.input_dark;
    isTouchedClass = isTouched ? classes.placeholder_active_dark : classes.placeholder_dark;
  }

  useEffect(function () {
    var _fieldState$value;

    fieldState.value && setIsTouched(true);
    setCount(((_fieldState$value = fieldState.value) === null || _fieldState$value === void 0 ? void 0 : _fieldState$value.length) || 0);
  }, [fieldState.value]);

  var handleKeyPress = function handleKeyPress(e) {
    e.key === 'Tab' && setIsTouched(true);
  };

  var handleBlur = function handleBlur(rest) {
    !fieldState.value && setIsTouched(false);

    if (typeof (rest === null || rest === void 0 ? void 0 : rest.onBlur) === 'function') {
      rest.onBlur();
    }
  };

  return React.createElement("div", {
    className: "relative"
  }, React.createElement(InformedTextArea, _extends({
    maxLength: maxLength,
    onClick: function onClick() {
      return setIsTouched(true);
    },
    onKeyUp: handleKeyPress
  }, rest, {
    className: inputClass,
    field: field,
    onBlur: function onBlur() {
      handleBlur(rest);
    }
  })), React.createElement("span", {
    className: isTouchedClass
  }, placeholder), counter && React.createElement(CharacterCounter, {
    classes: {
      limit: "".concat(classes.counterLimit, " ").concat(((_fieldState$value2 = fieldState.value) === null || _fieldState$value2 === void 0 ? void 0 : _fieldState$value2.length) === 350 ? classes.maxLetters : '')
    },
    count: (_fieldState$value$len = (_fieldState$value3 = fieldState.value) === null || _fieldState$value3 === void 0 ? void 0 : _fieldState$value3.length) !== null && _fieldState$value$len !== void 0 ? _fieldState$value$len : count,
    max: maxLength
  }), React.createElement(Message, {
    classes: {
      root: classes.message,
      root_error: classes.message_error
    },
    fieldState: fieldState
  }, message));
};

export default TextArea;
TextArea.defaultProps = {
  cols: 40,
  rows: 4,
  wrap: 'hard'
};
TextArea.propTypes = {
  classes: shape({
    input: string
  }),
  cols: oneOfType([number, string]),
  field: string.isRequired,
  message: node,
  rows: oneOfType([number, string]),
  wrap: oneOf(['hard', 'soft'])
};